import { Component, Input } from '@angular/core';
import { Payload } from '../../models/patient-details.model';

@Component({
  selector: 'app-patient-demographics',
  templateUrl: './patient-demographics.component.html',
  styleUrls: ['./patient-demographics.component.scss'],
  standalone: false
})
export class PatientDemographicsComponent {
  @Input() patientPayload: Payload | null = null;
}